import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getMessage } from 'util/locale';

// components
import Gradient from 'mapping/legends/Gradient';

const baseString = 'vra-legend';
const Legend = ({
  className,
  colors,
  displayValues=[],
  highLabel,
  isEditable,
  lowLabel,
  title,
  toggleEditLegend
}) => {
  const classString = classNames({
    [`${baseString}`]: true,
    [`${className}`]: !!className
  });

  const highLabelClassString = classNames({
    [`${baseString}__label`]: true,
    [`${baseString}__label--high`]: true
  });

  const lowLabelClassString = classNames({
    [`${baseString}__label`]: true,
    [`${baseString}__label--low`]: true
  });

  return (
    <section className={classString}>
      {isEditable && (<div
        className={`${baseString}__edit`}
        onClick={(e) => {
          e.stopPropagation();
          toggleEditLegend();
        }
        }>
        {getMessage('title-text__edit')}
      </div>)}
      {title && <header className={`${baseString}__title`}>{title}</header>}
      <figcaption className={highLabelClassString}>
        {highLabel}
      </figcaption>
      <figcaption className={lowLabelClassString} 
        data-test-id={`${baseString}-label-low`}>
        {lowLabel}
      </figcaption>
      <div className={`${baseString}__gradient-wrapper`}>
        <Gradient
          className={`${baseString}__gradient`}
          colors={colors}
          displayValues={displayValues}
        />
      </div>
    </section>
  );
};
Legend.propTypes = {
  className: PropTypes.string,
  colors: PropTypes.array.isRequired,
  displayValues: PropTypes.array,
  highLabel: PropTypes.string,
  isEditable: PropTypes.bool,
  lowLabel: PropTypes.string,
  title: PropTypes.string,
  toggleEditLegend: PropTypes.func
};
export default Legend;
